import { useState } from "react";
import Button from "../lds/Button";
import Chip from "../lds/chips/Chip";
import Spacer from "../lds/Spacer";
import Body from "../lds/table/Body";
import Cell from "../lds/table/Cell";
import Header from "../lds/table/Header";
import Row from "../lds/table/Row";
import Table from "../lds/table/Table";
import Heading from "../lds/typography/Heading";
import Accordion, {
  AccordionContent,
  AccordionTrigger,
} from "../lds/accordion/Accordion";

export default function ColleaguesFeedsTableGroup({ feedMonitors, letter }) {
  const names = Object.keys(feedMonitors);

  return (
    <div className="feed-monitor-group">
      <Heading size="h2">
        {letter}
      </Heading>
      {names.map((name) => (
        <ColleagesFeedTable key={name} feedMonitor={feedMonitors[name]} />
      ))}
    </div>
  );
}

function ColleagesFeedTable({ feedMonitor }) {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);
  const username = feedMonitor[0].username;

  const copyFeed = (feed) => {
    feed_action("clone", feed.feed_id, "new cloned feed");
  };

  return (
    <Accordion open={open}>
      <AccordionTrigger onClick={toggle}>
        <Table width="100%">
          <Header>
            <Row className="colleagues-feed-header" header selected={open}>
              <Cell header onClick={toggle}>
                {username} ({feedMonitor.length})
                <Spacer />
                <Chip
                  leadingIcon={
                    "chevron-" + (open ? "up-centered" : "down-centered")
                  }
                  label=""
                  selected={open}
                  size="small"
                  variant={open ? "primary" : "secondary"}
                />
              </Cell>
            </Row>
          </Header>
        </Table>
      </AccordionTrigger>
      <AccordionContent>
        <Table width="100%">
          <Body>
            {feedMonitor.map((feed) => (
              <Row key={feed.feed_id} id={"feed_" + feed.feed_id}>
                <Cell>
                  <a
                    className="lds-text-link colleague_feed_link"
                    href={`/feeds/${feed.feed_id}/display_saved_feed`}
                  >
                    {feed.feed_name}
                  </a>
                  <Spacer />
                  <Button
                    className="rspec_clone_this_feed"
                    size="small"
                    variant="secondary"
                    onClick={() => copyFeed(feed)}
                  >
                    Copy Feed
                  </Button>
                </Cell>
              </Row>
            ))}
          </Body>
        </Table>
      </AccordionContent>
    </Accordion>
  );
}
